// extracted by mini-css-extract-plugin
module.exports = {"Small":"style_Small__2XeYG","unchecked":"style_unchecked__1ZagX","checked":"style_checked__3ez8J","indeterminate":"style_indeterminate__1miyn","disabled":"style_disabled__3Mywq"};